var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 72,
    viewBox: "0 0 320 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13517_18746)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 72,
    rx: 16,
    fill: "url(#paint0_linear_13517_18746)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 72,
    rx: 16,
    fill: "url(#paint1_linear_13517_18746)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.625,
    width: 318.75,
    height: 70.75,
    rx: 15.375,
    stroke: "url(#paint2_linear_13517_18746)",
    strokeOpacity: 0.3,
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 72,
    rx: 16,
    fill: "url(#paint3_linear_13517_18746)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_13517_18746)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7926 38C60.9033 38 61.9792 37.8521 63 37.5708C62.188 37.3997 61.3441 37.3098 60.4828 37.3098H46.1394C43.7701 37.3098 41.5603 36.6312 39.6898 35.4567C40.0987 33.0671 41.2239 30.7732 43.0712 28.9288L52.2381 19.7619C53.024 18.976 53.6765 18.1118 54.2043 17.1925C53.5083 17.6449 52.85 18.1785 52.2381 18.7875L42.0939 28.9317C40.4177 30.6079 38.3761 31.6896 36.2243 32.1826C34.8236 30.2019 34 27.7862 34 25.1762V12.2074C34 11.0967 33.8521 10.0208 33.5708 9C33.3997 9.812 33.3098 10.653 33.3098 11.5172V25.8606C33.3098 28.2299 32.6312 30.4397 31.4567 32.3102C29.0671 31.9013 26.7732 30.7761 24.9288 28.9288L15.7619 19.7619C14.976 18.976 14.1118 18.3206 13.1925 17.7957C13.6449 18.4917 14.1785 19.15 14.7875 19.7619L24.9317 29.9061C26.6079 31.5823 27.6896 33.6239 28.1826 35.7757C26.2019 37.1764 23.7862 38 21.1762 38H8.2074C7.0967 38 6.0208 38.1479 5 38.4292C5.812 38.6003 6.653 38.6902 7.5172 38.6902H21.8606C24.2299 38.6902 26.4397 39.3688 28.3102 40.5433C27.9013 42.9329 26.7761 45.2268 24.9288 47.0712L15.7619 56.2381C14.976 57.024 14.3206 57.8882 13.7957 58.8075C14.4917 58.3551 15.15 57.8215 15.7619 57.2125L25.9061 47.0683C27.5823 45.3921 29.6239 44.3104 31.7757 43.8174C33.1764 45.7981 34 48.2138 34 50.8238V63.7897C34 64.9004 34.1479 65.9763 34.4292 66.9971C34.6003 66.1851 34.6902 65.3412 34.6902 64.4799V50.1365C34.6902 47.7672 35.3688 45.5574 36.5433 43.6869C38.9329 44.0958 41.2268 45.221 43.0712 47.0683L52.2381 56.2352C53.024 57.0211 53.8882 57.6736 54.8075 58.2014C54.3551 57.5054 53.8215 56.8471 53.2125 56.2352L43.0683 46.091C41.3921 44.4148 40.3104 42.3732 39.8203 40.2214C41.801 38.8207 44.2167 37.9971 46.8267 37.9971H59.7926V38Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 246.5,
    cy: 66.5,
    r: 19.5,
    fill: "url(#paint4_linear_13517_18746)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 240,
    cy: 2,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 303,
    cy: 70,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 309.5,
    cy: 5.5,
    r: 33.5,
    fill: "url(#paint5_linear_13517_18746)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.23 29.3359C313.446 31.1561 315.174 31.5084 315.174 31.5084C314.184 32.2632 314.193 32.7665 314.142 33.8821C313.06 33.4375 312.146 32.7246 311.433 31.7013C311.081 30.7199 311.433 29.9566 312.238 29.3443L312.23 29.3359Z",
    fill: "#F9D04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.23 51.3359C303.446 53.1561 305.174 53.5084 305.174 53.5084C304.184 54.2632 304.193 54.7665 304.142 55.8821C303.06 55.4375 302.146 54.7246 301.433 53.7013C301.081 52.7199 301.433 51.9566 302.238 51.3443L302.23 51.3359Z",
    fill: "#F94EE8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13517_18746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.957 26.6457L255.415 19.8534C252.681 19.2829 249.991 21.0914 249.407 23.8929L243.509 52.1469C242.925 54.9485 244.667 57.6821 247.4 58.2526L279.942 65.0449C282.676 65.6155 285.366 63.8069 285.951 61.0054L291.848 32.7514C292.433 29.9498 290.691 27.2162 287.957 26.6457Z",
    fill: "url(#paint6_radial_13517_18746)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297.276 17.8798C297.344 18.0295 297.481 18.1364 297.642 18.1657L298.681 18.3535C299.088 18.4273 299.234 18.9361 298.928 19.2151L298.145 19.9288C298.024 20.0393 297.965 20.2024 297.987 20.3651L298.127 21.4107C298.183 21.8212 297.744 22.1171 297.384 21.9116L296.467 21.3874C296.324 21.3056 296.149 21.2996 296.001 21.3713L295.05 21.8306C294.677 22.011 294.259 21.6847 294.343 21.2788L294.558 20.2428C294.592 20.0816 294.544 19.9142 294.43 19.7953L293.702 19.0357C293.416 18.7365 293.597 18.2386 294.008 18.1929L295.055 18.0769C295.218 18.0588 295.362 17.9618 295.44 17.8174L295.944 16.8842C296.141 16.5201 296.669 16.5387 296.84 16.9156L297.276 17.8798Z",
    fill: "#B0AFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.272 24.8954C239.34 25.0451 239.477 25.152 239.638 25.1813L240.677 25.3692C241.084 25.4429 241.23 25.9518 240.924 26.2307L240.141 26.9444C240.02 27.055 239.961 27.218 239.983 27.3807L240.123 28.4263C240.179 28.8368 239.739 29.1327 239.38 28.9272L238.463 28.403C238.319 28.3213 238.145 28.3153 237.997 28.3869L237.046 28.8462C236.673 29.0266 236.255 28.7003 236.339 28.2944L236.554 27.2584C236.588 27.0972 236.54 26.9299 236.426 26.8109L235.698 26.0516C235.412 25.7523 235.593 25.2543 236.005 25.2088L237.056 25.0925C237.22 25.0744 237.364 24.9771 237.442 24.8322L237.941 23.9031C238.137 23.5382 238.666 23.5563 238.837 23.9336L239.272 24.8954Z",
    fill: "#F9D04E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.276 55.8759C279.344 56.0256 279.481 56.1325 279.643 56.1618L280.681 56.3496C281.088 56.4234 281.235 56.9322 280.929 57.2112L280.145 57.9249C280.024 58.0354 279.965 58.1985 279.987 58.3612L280.128 59.4068C280.183 59.8173 279.744 60.1132 279.384 59.9077L278.467 59.3835C278.324 59.3017 278.15 59.2957 278.001 59.3674L277.05 59.8267C276.677 60.0071 276.259 59.6808 276.343 59.2748L276.558 58.2389C276.592 58.0777 276.544 57.9103 276.43 57.7914L275.703 57.0321C275.416 56.7328 275.597 56.2348 276.009 56.1892L277.06 56.073C277.224 56.0549 277.368 55.9575 277.446 55.8126L277.945 54.8836C278.141 54.5187 278.67 54.5367 278.841 54.9141L279.276 55.8759Z",
    fill: "#927AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.943 47.2594C278.743 47.2174 278.558 47.1235 278.405 46.9871C278.253 46.8508 278.139 46.6767 278.075 46.4824L271.267 25.9269L257.448 41.4741C257.346 41.5886 257.222 41.6817 257.084 41.7484C256.946 41.815 256.796 41.8538 256.643 41.8625C256.49 41.8712 256.336 41.8496 256.192 41.7991C256.047 41.7485 255.913 41.67 255.799 41.5678C255.685 41.4657 255.591 41.3421 255.525 41.204C255.458 41.0658 255.419 40.9159 255.411 40.7628C255.402 40.6097 255.424 40.4564 255.474 40.3116C255.525 40.1668 255.603 40.0334 255.705 39.919L272.216 21.3235L280.295 45.7187C280.392 46.0122 280.368 46.332 280.229 46.6079C280.09 46.8838 279.847 47.0932 279.553 47.1902C279.361 47.2697 279.149 47.2936 278.943 47.2594Z",
    fill: "#927AF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.947 61.9292L262.665 61.4528L262.524 62.1269C262.527 62.1087 262.531 62.0906 262.534 62.0725L270.347 24.6441C270.411 24.3334 270.594 24.0606 270.854 23.8856C271.114 23.7106 271.43 23.6478 271.733 23.711C272.036 23.7742 272.3 23.9582 272.468 24.2226C272.637 24.487 272.695 24.81 272.63 25.1207L264.947 61.9292Z",
    fill: "#927AF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.58 32.6506L290.024 41.5096L290.501 39.2262L248.057 30.3672L247.58 32.6506Z",
    fill: "#927AF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.767 23.8003L273.079 24.0742L273.07 24.0325C282.151 25.4952 285.549 22.6561 286.786 19.9156C287.03 19.3794 287.155 18.7968 287.152 18.2078C287.15 17.6188 287.02 17.0373 286.771 16.5032C286.523 15.9691 286.162 15.4952 285.713 15.1139C285.264 14.7325 284.737 14.4529 284.17 14.2942C279.304 12.9279 274.426 17.3338 272.013 19.9936C270.866 16.5915 268.16 10.5976 263.152 9.90301C262.568 9.8216 261.974 9.8674 261.41 10.0373C260.846 10.2072 260.326 10.4971 259.884 10.8872C259.443 11.2773 259.091 11.7582 258.853 12.2971C258.615 12.8359 258.497 13.4199 258.506 14.0089C258.542 17.021 260.522 20.9781 269.433 23.2694L269.403 23.3109L271.172 23.6803C271.373 23.7222 271.571 23.7621 271.767 23.8003ZM262.832 12.2072L263.117 12.2667L263.135 12.2646C266.583 12.9843 268.858 17.784 269.89 20.9721C264.067 19.4468 260.873 16.9989 260.842 13.9781C260.838 13.7235 260.89 13.4711 260.994 13.2387C261.098 13.0063 261.252 12.7994 261.444 12.6324C261.632 12.4664 261.853 12.3425 262.092 12.2692C262.331 12.1958 262.584 12.1747 262.832 12.2072ZM273.565 21.7492C275.804 19.2438 279.831 15.7595 283.256 16.4744L283.541 16.5397C283.781 16.6092 284.004 16.7295 284.194 16.8925C284.384 17.0555 284.537 17.2573 284.642 17.4845C284.752 17.7144 284.81 17.9654 284.812 18.2201C284.814 18.4747 284.761 18.7268 284.656 18.9588C283.42 21.715 279.513 22.6808 273.565 21.7492Z",
    fill: "#FFD0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13517_18746",
    x: 1,
    y: 5,
    width: 66,
    height: 65.9961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_13517_18746"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13517_18746",
    x: 239.396,
    y: 17.75,
    width: 56.5645,
    height: 53.3984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13517_18746"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13517_18746",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13517_18746",
    x1: 8,
    y1: 43.0541,
    x2: 261.329,
    y2: 151.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD79F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA59AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13517_18746",
    x1: 14.5,
    y1: 9.00003,
    x2: 257,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629691,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13517_18746",
    x1: 62.3377,
    y1: -4.5,
    x2: 83.3429,
    y2: 82.4598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13517_18746",
    x1: 123,
    y1: 26.5,
    x2: 203.329,
    y2: 81.5539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566508,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13517_18746",
    x1: 246.5,
    y1: 47,
    x2: 246.5,
    y2: 86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13517_18746",
    x1: 298.5,
    y1: 6,
    x2: 283.5,
    y2: 48.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_13517_18746",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(285.615 30.6745) rotate(125.316) scale(37.9595 42.2913)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA7E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13517_18746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 72,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRewards);
export default __webpack_public_path__ + "static/media/StarRewards.7ca289812510194d2f8e71182dff4b1e.svg";
export { ForwardRef as ReactComponent };